import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
import { Route } from 'vue-router';
import store from '@/store';

export default [
    {
        path: '/team/manage/detail/:activityId/:teamId', // :teamId 战队id
        name: ROUTE_NAME.TEAM_MANAGE_DETAIL,
        meta: {
            title: '战队管理',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            disableShare: true,
            checkMonitor: true,
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "monitor" */ '@/pages/team/manage/detail.vue'),
    },
    {
        path: '/team/manage/list/:activityId',
        name: ROUTE_NAME.TEAM_MANAGE_LIST,
        meta: {
            title: '战队管理',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            disableShare: true,
            checkMonitor: true,
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "monitor" */ '@/pages/team/manage/list.vue'),
    },
    {
        path: '/team/recruit_rank/:activityId',
        name: ROUTE_NAME.TEAM_RECRUIT_RANK,
        meta: {
            title: '队长招募榜',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            disableShare: true,
            checkMonitor: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "monitor" */ '@/pages/team/recruitRank.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/team/manage/influence/:teamId/:activityId', // teamId: 战队id
        name: ROUTE_NAME.TEAM_MANAGE_INFLUENCE,
        meta: {
            title: '影响人数',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            disableShare: true,
            checkMonitor: true,
            needBinding: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "monitor" */ '@/pages/team/manage/influence.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/team/share/:activityId',
        name: ROUTE_NAME.TEAM_SHARE,
        meta: {
            title: '邀请队长分享',
            scrollBehavior: 'top',
            needBinding: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "monitor" */ '@/pages/team/share.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/monitor/redirect/:activityId',
        name: ROUTE_NAME.MONITOR_REDIRECT,
        meta: {
            title: '',
        },
        component: () => ({
            component: import(/* webpackChunkName: "monitor" */ '@/pages/monitor/redirect.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/monitor/activity_list',
        name: ROUTE_NAME.MONITOR_ACTIVITY_LIST,
        component: () => import(/* webpackChunkName: "monitor" */ '@/pages/monitor/activityList.vue'),
    },
    {
        path: '/monitor/setting_before/:activityId/:teamId', // :teamId 战队id
        name: ROUTE_NAME.MONITOR_SETTING_BEFORE,
        meta: {
            title: '战队设置',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needBinding: true,
            disableShare: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "monitor" */ '@/pages/monitor/settingBefore.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/monitor/setting/:activityId/:teamId', // :teamId 战队id
        name: ROUTE_NAME.MONITOR_SETTING,
        meta: {
            title: (to: Route) => {
                const activityId = to.params.activityId;
                const basicInfo = store.state.activity.basicInfo[activityId];
                return `${basicInfo ? basicInfo.name : ''}战队信息更新`;
            },
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needBinding: true,
            disableShare: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "monitor" */ '@/pages/monitor/setting.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/monitor/setting/:teamId', // :teamId 战队id
        async beforeEnter(to: Route, from: Route, next: any) {
            const teamId = to.params.teamId;
            store.commit('startRequest');
            await store.dispatch('activity/getTeamDetail', {
                teamId,
            });
            store.commit('endRequest');
            const team = store.state.activity.team.detail[Number(teamId)];
            if (!team) {
                next(false);
                return;
            }
            next({
                name: ROUTE_NAME.MONITOR_SETTING_BEFORE,
                params: {
                    activityId: team.activity_id,
                    teamId,
                },
            });
        },
    },
    {
        path: '/team/manage/signin/detail/:activityId/:teamId/:date/:nav?', // :teamId 战队id date 选中的日期 nav 类型
        name: ROUTE_NAME.TEAM_MANAGE_SIGNIN_DETAIL,
        meta: {
            title: '打卡明细',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needBinding: true,
            disableShare: true,
            checkMonitor: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "monitor" */ '@/pages/team/manage/signInDetail.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/team/manage/signin/calendar/:activityId/:teamId/:userId/:date', // userId 用户id date时间
        name: ROUTE_NAME.TEAM_MANAGE_SIGNIN_CALENDAR,
        meta: {
            title: '打卡日历',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needBinding: true,
            disableShare: true,
            checkMonitor: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "monitor" */ '@/pages/team/manage/signInCalendar.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/monitor/invite/:activityId', // :activityId 活动id
        name: ROUTE_NAME.MONITOR_INVITE,
        meta: {
            title: '邀请队长，可得1000元奖金',
            scrollBehavior: 'top',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "monitor" */ '@/pages/monitor/invite.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/monitor/invite_team/:activityId', // :activityId 活动id
        name: ROUTE_NAME.MONITOR_INVITE_TEAM,
        meta: {
            title: '邀请队伍',
            scrollBehavior: 'top',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "monitor" */ '@/pages/monitor/inviteTeam.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/monitor/invite_team_detail/:teamId', // :teamId 队伍id
        name: ROUTE_NAME.MONITOR_INVITE_TEAM_DEATIL,
        meta: {
            title: '邀请队伍',
            scrollBehavior: 'top',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "monitor" */ '@/pages/monitor/inviteTeamDetail.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/monitor/question/:activityId/:predicatedMemberCount',
        name: ROUTE_NAME.MONITOR_QUESTION,
        meta: {
            title: '申请表单',
            scrollBehavior: 'top',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "monitor" */ '@/pages/monitor/question.vue'),
    },
    {
        path: '/monitor/result/:activityId',
        name: ROUTE_NAME.MONITOR_RESULT,
        meta: {
            title: '笔试结果',
            scrollBehavior: 'top',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "monitor" */ '@/pages/monitor/result.vue'),
    },
    {
        path: '/monitor/team/:activityId',
        name: ROUTE_NAME.MONITOR_TEAM,
        meta: {
            title: '创建战队',
            scrollBehavior: 'top',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "monitor" */ '@/pages/monitor/team.vue'),
    },
    {
        path: '/monitor/interview/:activityId',
        name: ROUTE_NAME.MONITOR_INTERVIEW,
        meta: {
            title: '面试',
            scrollBehavior: 'top',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "monitor" */ '@/pages/monitor/interview.vue'),
    },
];
